import Vue from "vue";
import { prepareSessionForUserWithNoAccountRequired, signOut } from "@/apis/auth";
import { REGISTRATION_TYPE } from "@/constants/config";
import Company from "@/models/Company";

export const setOnboardingStateIfTypeIsRegistration = async (type, commit) => {
    // * if the registration type exists this mean user (non-admin) want to create a new company
    // * so we need to set the active company (backend session id) to 0 which will handle rest
    if (type && REGISTRATION_TYPE.TYPES.includes(type))
    {
        commit('company/SET_REGISTRATION_TYPE', type, { root: true });
        await Company.setOnboardingState();
    }
};

export const isInSignAllPage = path => path[1] === 'signing-list' && path[3] === 'documents' && path[4] === 'all';

export const prepareGuestSigningSessionData = async (queryData, isVerifiedUser, commit) => {
    const sessionData = await prepareSessionForUserWithNoAccountRequired(queryData);
    if (sessionData) {
        commit('document/SET_DOCUMENTS_COMPANY_PROCESS_ID', sessionData.company_process_id, { root: true });
        if (sessionData.is_verified_user === 'no') {
            Vue.prototype.$cache.set('redirect-to-password-reset', true);
            Vue.prototype.$cache.set('reset-token', sessionData.reset_token);
            Vue.prototype.$cache.set('email', sessionData.email);
            localStorage.setItem('token', sessionData.token);
        }
    } else {
        commit('document/SET_DOCUMENTS_COMPANY_PROCESS_ID', null, { root: true });
        Vue.prototype.$cache.remove('redirect-to-password-reset');
        Vue.prototype.$cache.remove('reset-token');
        Vue.prototype.$cache.remove('email');
        localStorage.removeItem('token');
    }
};

export const cleanUpGuestSessionDataAndLogGuessOut = async commit => {
    commit('document/SET_DOCUMENTS_COMPANY_PROCESS_ID', null, { root: true });
    localStorage.removeItem('token');
    await signOut();
};

export const prepareAuthenticatedUserSigningSessionData = (processId, commit) => {
    Vue.prototype.$cache.remove('redirect-to-password-reset');
    if (processId) {
        commit('document/SET_DOCUMENTS_COMPANY_PROCESS_ID', processId, { root: true });
    }

    commit('document/SET_DOCUMENTS_INTENDED_ROUTE_PARAMS', {
        process: processId,
        document: 'all',
    }, { root: true });
};